export default __webpack_public_path__ + "static/media/wolf_license.a9b131fc.pdf";